"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@mui/material/Grid"));

var _IDNumberComponent = _interopRequireDefault(require("../../FormFields/IDField/IDNumberComponent"));

var _PassportComponent = _interopRequireDefault(require("../../FormFields/PassportField/PassportComponent"));

var _IDTypeSelectComponent = _interopRequireDefault(require("../../FormFields/IDTypeSelect/IDTypeSelectComponent"));

var _Enums = require("../../../Helpers/Enums");

var _reactFinalForm = require("react-final-form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDPassportComponent = function IDPassportComponent(props) {
  var idtype = (0, _reactFinalForm.useField)("idtype").input.value;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    md: 4,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_IDTypeSelectComponent.default, {
    allowedoptions: [_Enums.IDType.RSA_Id, _Enums.IDType.Passport]
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    md: 8,
    xs: 7
  }, idtype === _Enums.IDType.RSA_Id ? /*#__PURE__*/_react.default.createElement(_IDNumberComponent.default, null) : idtype === _Enums.IDType.Passport ? /*#__PURE__*/_react.default.createElement(_PassportComponent.default, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)));
};

var _default = IDPassportComponent;
exports.default = _default;